<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <estime v-if="sas" :sasId="sas.id"></estime>
    <introduction v-show="step == 'introduction'" endpoint="modification-formation-reconnue" @next-step="next"></introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submit" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import Informations from "@/components/ModificationFormationReconnue/Informations"
import Formateurs from "@/components/ModificationFormationReconnue/Formateurs"
import InfosActivite from "@/components/ModificationFormationReconnue/InfosActivite"
import InfosCatalogue from "@/components/ModificationFormationReconnue/InfosCatalogue"
import Engagements from "@/components/ModificationFormationReconnue/Engagements"
import Soumission from "@/components/FormParts/Soumission"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/modification-formation-reconnue/",
      paramsName: "reconnaissance-formation",
      loadPanierOnLoad: true,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "informations", code: "titre-etape-1", state: "" },
        { path: "formateurs", code: "titre-etape-2", state: "" },
        { path: "infos-activite", code: "titre-etape-3", state: "" },
        { path: "infos-catalogue", code: "titre-etape-4", state: "" },
        { path: "engagements", code: "titre-etape-5", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    Introduction,
    Informations,
    Formateurs,
    InfosActivite,
    InfosCatalogue,
    Engagements,
    Soumission
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style>
</style>